import Ajax from 'modules/dashboard/utils/Ajax';

let intervalId = null;
const EXTEND_BUFFER = 5; // 5 seconds
const MIN_TIMEOUT = 60; // 1 minute
const getOptions = ({url, user: {consoleSessionId}}) => ({
  headers: [
    {
      header: 'nexposeCCSessionID',
      value: consoleSessionId,
    },
  ],
  url,
  withCredentials: true,
});

const clearRefreshOnPremSessionInterval = () =>
  intervalId && clearInterval(intervalId);
const calculateInterval = (timeout) =>
  ((timeout > MIN_TIMEOUT ? timeout : MIN_TIMEOUT) - EXTEND_BUFFER) * 1000;
const touchSession = (user, consoleUrl) =>
  Ajax(
    getOptions({
      url: `${consoleUrl}/data/session/touch`,
      user,
    })
  ).catch(({xhr = {}, status}) => {
    if (xhr.status === 403 || status === 0) {
      clearRefreshOnPremSessionInterval();
    }
  });

const refreshSession = ({user, consoleUrl}) =>
  Ajax({
    ...getOptions({
      url: `${consoleUrl}/data/session/info`,
      user,
    }),
    parse: JSON.parse,
  })
    .then(({timeout = MIN_TIMEOUT}) => {
      intervalId = setInterval(
        () => touchSession(user, consoleUrl),
        calculateInterval(timeout)
      );
    })
    .catch(() => {
      clearRefreshOnPremSessionInterval();
    });

export default {
  clearRefreshSessionInterval: clearRefreshOnPremSessionInterval,
  refreshSessionOnInterval: refreshSession,
};
